﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const GenericForm_1 = require("./GenericForm");
const Utils_1 = require("../../Utils");
class ExtendedFields extends React.Component {
    render() {
        let content = null;
        if (this.props.fields && this.props.fields.length > 0) {
            content = (React.createElement(GenericForm_1.GenericForm, { fields: this.props.fields, onChange: this.props.onChange, valueToEdit: this.props.valuesToEdit, legend: this.props.texts.legend, id: Utils_1.PrefixId.ExtendedFields }));
        }
        return content;
    }
}
exports.ExtendedFields = ExtendedFields;
//# sourceMappingURL=ExtendedFields.js.map